<template>
  <div>
    <form class="form-horizontal">
      <h1 class="section-divider">{{ $t('profileApproval.currentInfo') }}</h1>
      <div class="row" style="font-size: 12px;">
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.nameKh') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_name_kh ? info.father_name_kh : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.nameEn') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_name_en ? info.father_name_en : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.dateOfBirth') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_dob ? info.father_dob : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.nationality') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_nationality
                  ? info.father_nationality.nationality
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.religion') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_religion ? info.father_religion : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.occupation') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_occupation
                  ? info.father_occupation.occupation_name_en
                  : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.phoneLine1') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_phone1 ? info.father_phone1 : '-'
              }}</label>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.phoneLine2') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_phone2 ? info.father_phone2 : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.email') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_emails ? info.father_emails : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.facebook') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_facebook ? info.father_facebook : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.line') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_line ? info.father_line : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.linkIn') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_linked_in ? info.father_linked_in : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.telegram') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_telegram ? info.father_telegram : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.wechat') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.father_wechat ? info.father_wechat : '-'
              }}</label>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.province') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.province ? info.province.province_name : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.district') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.district ? info.district.district_name : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.commune') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.commune ? info.commune.commune_name : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.village') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.village ? info.village.village_name : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.streetNo') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.street ? info.street : '-'
              }}</label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.houseNo') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label class="col-md-5 form-col-label control-label text-left">{{
                info.house_no ? info.house_no : '-'
              }}</label>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <div class="col-md-12 text-center">
              <div id="img-frame" class="text-center">
                <img
                  v-lazy="{
                    src: photoFather(info),
                    error: onErrorFather(),
                    loading: require('@/assets/Rolling-1s-200px_2.svg')
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'fatherCurrentInfo',
  props: ['info', 'edit'],
  data() {
    return {
      data: {},
      errors: new Errors(),
      manPhoto: require('../../../../../assets/staff-default-man.png'),
      file: require('../../../../../assets/user_default.png')
    }
  },
  methods: {
    photoFather(record) {
      if (record) {
        return record.father_photo
      }
      return this.manPhoto
    },
    onErrorFather() {
      event ? (event.target.src = this.manPhoto) : ''
    }
  }
}
</script>
<style lang="css" scoped>
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.section-divider {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin-top: 5px;
}
#img-frame img {
  object-fit: contain;
  width: 45%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
